module.exports = __webpack_public_path__ + "static/img/cjfw-companyProducts7.e2963640.png";